import { motion } from "framer-motion";
import { Overline } from "./Mark";
import { Reveal } from "./Reveal";

const MARKETS = [
  { code: "US", name: "United States", img: "/img/us.jpg", alt: "Manhattan skyline at dusk", text: "Property marketing and enquiries relating to selected projects and real-estate opportunities." },
  { code: "UK", name: "United Kingdom", img: "/img/uk.jpg", alt: "White stucco London townhouse with blossom", text: "Property marketing and enquiries relating to selected developments and real-estate opportunities." },
  { code: "NL", name: "Netherlands", img: "/img/nl.jpg", alt: "Amsterdam canal houses", text: "Property marketing and enquiries relating to selected developments and real-estate opportunities." },
];

const ease = [0.76, 0, 0.24, 1];

const Row = ({ m, i }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.15 }}
    className="group grid items-center gap-8 border-t border-[rgba(212,175,55,0.18)] py-12 lg:grid-cols-12 lg:gap-10 lg:py-16"
    data-testid={`market-row-${m.code.toLowerCase()}`}
  >
    <motion.div variants={{ hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0, transition: { duration: 0.9 } } }} className="lg:col-span-6">
      <div className="flex items-baseline gap-5">
        <span className="font-mono-d text-xs tracking-[0.2em] text-[#D4AF37]">0{i + 1}</span>
        <span className="font-mono-d rounded-full border border-[rgba(212,175,55,0.3)] px-3 py-1 text-xs text-[#E6C280]">{m.code}</span>
      </div>
      <h3 className="font-serif-d mt-5 text-5xl font-medium leading-none text-white transition-colors duration-500 group-hover:text-[#E6C280] sm:text-6xl lg:text-7xl">{m.name}</h3>
      <p className="mt-6 max-w-md text-base leading-relaxed text-slate-300">{m.text}</p>
    </motion.div>
    <div className={`lg:col-span-6 ${i % 2 ? "lg:order-first" : ""}`}>
      <motion.div
        variants={{ hidden: { clipPath: "inset(12% 12% 12% 12% round 24px)" }, show: { clipPath: "inset(0% 0% 0% 0% round 24px)", transition: { duration: 1.4, ease } } }}
        className="relative aspect-[16/10] overflow-hidden"
      >
        <motion.img
          variants={{ hidden: { scale: 1.3 }, show: { scale: 1, transition: { duration: 1.6, ease } } }}
          src={m.img}
          alt={m.alt}
          className="h-full w-full object-cover grayscale-[35%] transition-[filter] duration-700 group-hover:grayscale-0"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#070E17]/70 to-transparent" />
        <span className="font-serif-d absolute bottom-4 right-6 text-6xl italic text-white/80">{m.code}</span>
      </motion.div>
    </div>
  </motion.div>
);

export const Markets = () => (
  <section id="markets" className="bg-[#0B192C] py-24 lg:py-36" data-testid="markets-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <Reveal className="max-w-3xl">
        <Overline>Our Markets — 03</Overline>
        <h2 className="font-serif-d mt-6 text-4xl font-medium leading-[1.02] text-white sm:text-5xl lg:text-6xl">Three markets. <em className="gold-text italic">One standard</em> of communication.</h2>
      </Reveal>
      <div className="mt-16">
        {MARKETS.map((m, i) => <Row key={m.code} m={m} i={i} />)}
      </div>
      <Reveal>
        <p className="border-t border-[rgba(212,175,55,0.18)] pt-8 text-sm leading-relaxed text-slate-400" data-testid="markets-brand-note">
          We may support marketing campaigns involving properties associated with established real-estate brands, subject to the applicable business arrangements.
        </p>
      </Reveal>
    </div>
  </section>
);
